
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request-quotes",
      function () {
        return require("private-next-pages/request-quotes.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/request-quotes"])
      });
    }
  